webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  user: {
    authenticated: false
  },

  login: function login(context, username, password, successCB, errorCB) {
    // if success
    var self = this;
    var token = btoa(username + ':' + password);
    context.$axios.defaults.headers.common['Authorization'] = 'Basic ' + token;

    context.$axios.get("https://api.hippodata.net/").then(function (response) {
      localStorage.setItem('auth_token', token);
      self.user.authenticated = true;
      successCB(response);
    }).catch(function (error) {
      errorCB(error);
    });
  },
  logout: function logout(context) {},
  checkAuth: function checkAuth() {
    var token = localStorage.getItem('auth_token');
    if (token) {
      this.user.authenticated = true;
    } else {
      this.user.authenticated = false;
    }
  },
  getAuthToken: function getAuthToken() {
    return localStorage.getItem('auth_token');
  }
});

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Conflicts__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Conflicts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Conflicts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Login__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Conflicts',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Conflicts___default.a,
    meta: {
      auth: true
    }
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Login___default.a
  }]
});

router.beforeEach(function (to, from, next) {
  var authRequired = to.matched.some(function (route) {
    return route.meta.auth;
  });
  var authed = __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].user.authenticated;
  if (authRequired && !authed) {
    next('/login');
  } else {
    next();
  }
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(41)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(49),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_min_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







 // Ensure you are using css-loader

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('v-select', __WEBPACK_IMPORTED_MODULE_1_vue_select___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_4__auth__["a" /* default */].checkAuth();
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'] = 'Basic ' + __WEBPACK_IMPORTED_MODULE_4__auth__["a" /* default */].getAuthToken();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$auth = __WEBPACK_IMPORTED_MODULE_4__auth__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$axios = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navigation_vue__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_0__components_Navigation_vue___default.a
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'conflicts',
  data: function data() {
    return {
      totalNumberOfConflicts: 0,
      transitioning: false,
      hasErrors: false,
      errorDescription: '',
      currentConflict: {
        remainingProblems: 0
      },
      currentSolution: null,
      skippedConflicts: []
    };
  },

  methods: {
    solutionClick: function solutionClick(solution) {
      this.currentSolution = solution;
      this.hasErrors = false;
    },
    solveConflict: function solveConflict() {
      var _this = this;

      this.hasErrors = false;
      this.currentConflict.loading = true;
      if (this.currentSolution.choices && this.currentSolution.choices.length > 0 && this.currentSolution.choice == null) {
        this.hasErrors = true;
        this.errorDescription = 'You need to make a choice to solve this conflict!';
        this.currentConflict.loading = false;
        return;
      }
      var relatedEntityId = '';
      if (this.currentSolution.choice) {
        relatedEntityId = this.currentSolution.choice.relatedEntityId;
      }
      this.$axios.post("https://api.hippodata.net/" + 'problems/solve/' + this.currentConflict.id, {
        callMethod: this.currentSolution.callMethod,
        relatedEntityId: relatedEntityId
      }).then(function (response) {
        _this.currentConflict.loading = false;
        _this.getNextConflict();
      }).catch(function (error) {
        console.log(error);
        _this.hasErrors = true;
        _this.errorDescription = 'There was a problem solving this conflict on the server-side!';
        _this.currentConflict.loading = false;
      });
    },
    skipConflict: function skipConflict() {
      this.hasErrors = false;
      this.skippedConflicts.push(this.currentConflict.id);
      this.getNextConflict();
    },

    getNextConflict: function getNextConflict() {
      var _this2 = this;

      this.transitioning = true;

      var queryParams = '';

      if (this.skippedConflicts.length) {
        queryParams += '?skipped=';
        for (var i = 0; i < this.skippedConflicts.length; i++) {
          if (i !== 0) {
            queryParams += ',';
          }
          queryParams += this.skippedConflicts[i];
        }
      }

      return this.$axios.get("https://api.hippodata.net/" + 'problems/next' + queryParams).then(function (response) {
        _this2.currentConflict = response.data;
        // Parse data to be able to use in vue-select
        for (var j = 0; j < _this2.currentConflict.possibleSolutions.length; j++) {
          if (_this2.currentConflict.possibleSolutions[j].choices) {
            for (var k = 0; k < _this2.currentConflict.possibleSolutions[j].choices.length; k++) {
              var currentChoice = _this2.currentConflict.possibleSolutions[j].choices[k];
              currentChoice.label = currentChoice.value;
            }
          }
        }

        if (_this2.skippedConflicts.length && _this2.skippedConflicts[0] === _this2.currentConflict.id) {
          _this2.skippedConflicts.shift();
        }

        _this2.currentSolution = _this2.currentConflict.possibleSolutions[0];
        _this2.transitioning = false;
      }).catch(function (e) {
        if (e.response) {
          if (e.response.status === 404) {
            _this2.transitioning = false;
            _this2.currentConflict.remainingProblems = 0;
          }
        } else {
          console.log(e);
        }
      });
    }
  },
  created: function created() {
    var _this3 = this;

    this.$axios.get("https://api.hippodata.net/" + 'problems/count').then(function (response) {
      _this3.totalNumberOfConflicts = response.data;
    }).catch(function (e) {
      console.log(e);
    });
    this.getNextConflict();
  },

  computed: {
    progressValue: function progressValue() {
      if (this.totalNumberOfConflicts === 0) return 100;
      return 100 / this.totalNumberOfConflicts * (this.totalNumberOfConflicts - this.currentConflict.remainingProblems);
    }
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      valid: true,
      loginProblem: false,
      name: '',
      nameRules: [function (v) {
        return !!v || 'Name is required';
      }, function (v) {
        return v.length <= 10 || 'Name must be less than 10 characters';
      }],
      password: '',
      passwordRules: [function (v) {
        return !!v || 'Password is required';
      }]
    };
  },

  methods: {
    login: function login() {
      if (this.$refs.form.validate()) {
        var self = this;
        this.loginProblem = false;
        this.$auth.login(this, this.name, this.password, function (response) {
          self.$router.push('/');
        }, function (error) {
          self.loginProblem = true;
          console.log(error);
        });
      }
    }
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navigation'
});

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(38)
  __webpack_require__(39)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(47),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2008dd2a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(40)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(48),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-61feba32",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(50),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "value": _vm.progressValue,
      "height": "10",
      "info": ""
    }
  }), _vm._v(" "), (!_vm.transitioning && !_vm.currentConflict.remainingProblems) ? _c('v-card', [_c('v-card-title', [_vm._v("\n        Great. We have no open Conflicts!\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.currentConflict.remainingProblems && !_vm.transitioning) ? _c('v-card', [_c('v-card-title', [_vm._v("\n          " + _vm._s(_vm.currentConflict.description) + "\n        ")]), _vm._v(" "), _c('v-card-text', [_c('v-expansion-panel', _vm._l((_vm.currentConflict.possibleSolutions), function(solution, index) {
    return _c('v-expansion-panel-content', {
      key: index,
      attrs: {
        "value": index === 0
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.solutionClick(solution)
        }
      },
      slot: "header"
    }, [_vm._v(_vm._s(solution.title))]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
      staticClass: "grey darken-2"
    }, [_c('p', [_vm._v("\n                    " + _vm._s(solution.description) + "\n                  ")]), _vm._v(" "), (solution.choices.length) ? _c('v-select', {
      staticClass: "grey-lighten-3",
      attrs: {
        "options": solution.choices
      },
      model: {
        value: (_vm.currentSolution.choice),
        callback: function($$v) {
          _vm.currentSolution.choice = $$v
        },
        expression: "currentSolution.choice"
      }
    }) : _vm._e()], 1)], 1)], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "action-buttons"
  }, [_c('v-btn', {
    attrs: {
      "secondary": ""
    },
    on: {
      "click": _vm.skipConflict
    }
  }, [_vm._v("Skip")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.currentConflict.loading,
      "disabled": _vm.currentConflict.loading,
      "success": ""
    },
    on: {
      "click": _vm.solveConflict
    }
  }, [_vm._v("Solve")])], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "error": "",
      "dismissible": "",
      "transition": "scale-transition"
    },
    model: {
      value: (_vm.hasErrors),
      callback: function($$v) {
        _vm.hasErrors = $$v
      },
      expression: "hasErrors"
    }
  }, [_vm._v(_vm._s(_vm.errorDescription))])], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Please Log in!\n      ")]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name",
      "rules": _vm.nameRules,
      "counter": 10,
      "required": ""
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Password",
      "rules": _vm.passwordRules,
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "success": "",
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n            Log in\n          ")])], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "error": "",
      "dismissible": "",
      "icon": "warning",
      "value": "true"
    },
    model: {
      value: (_vm.loginProblem),
      callback: function($$v) {
        _vm.loginProblem = $$v
      },
      expression: "loginProblem"
    }
  }, [_vm._v("\n         Your username or password is incorrect!\n       ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "dark": ""
    }
  }, [_c('main', [_c('v-container', [_c('router-view')], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "navigation"
    }
  })
},staticRenderFns: []}

/***/ })
],[33]);


// WEBPACK FOOTER //
// static/js/app.e8c4820feda80638c51a.js